module.exports = __webpack_public_path__ + "img/BottomBanner.c5d78387.png";